import { multiTinLookup } from "../checkoutConstants";
import { promoOptionsData } from "./PromoCodeOptions";

// Money in the shape CartLineItem reads. These items are never charged for, so
// every amount is zero and the component renders "FREE" off the back of it.
const NO_CHARGE = { amount: "0.00", currency: null, formatted: "Free" };

const freeDisplayLineItem = ({ id, imageUrl, title, type }) => ({
  id,
  type,
  quantity: 1,
  product: { title, image: imageUrl ? { url: imageUrl } : null },
  discount: NO_CHARGE,
  subtotal: NO_CHARGE,
  total: NO_CHARGE,
});

// The tin selector names tins from the same lookup, so "Pods" shows as
// "Pink Grind Tin" here too rather than as the raw variant option.
const tinTitle = (tin) => {
  const targetTin = Object.values(multiTinLookup).find(({ variantTitles }) =>
    variantTitles.includes(tin.variant?.title),
  );

  if (targetTin) {
    return targetTin.title;
  }

  if (tin.variant?.title && tin.variant.title !== "Default Title") {
    return tin.variant.title;
  }

  return tin.product?.title;
};

/**
 * Stand-in line items for the freebies a customer picks during checkout: the
 * tin from the tin selector, and whichever promo code option they chose. Both
 * are added to the order behind the scenes, so the cart never hands them back
 * as line items of its own and the summary would otherwise show nothing.
 */
export const getFreeDisplayLineItems = (cart) => {
  const items = [];

  const selectedTin = cart.products
    .map((product) =>
      product.children?.find(
        (child) => child.type === "rule" && child.removed === false,
      ),
    )
    .find(Boolean);

  if (selectedTin) {
    items.push(
      freeDisplayLineItem({
        id: `free-tin-${selectedTin.id}`,
        imageUrl: (selectedTin.variant?.image || selectedTin.product?.image)
          ?.url,
        title: tinTitle(selectedTin),
        type: "gwp",
      }),
    );
  }

  // Keyed off the code the cart has actually accepted, not the one that was
  // clicked: a code that failed to apply shouldn't leave a product in the
  // summary the customer isn't getting.
  const appliedCode = cart.discount?.code;

  const promoItem = [promoOptionsData.itemA, promoOptionsData.itemB].find(
    (item) =>
      item.showItem &&
      appliedCode &&
      item.code.toUpperCase() === appliedCode.toUpperCase(),
  );

  if (promoOptionsData.showBlock && promoItem) {
    items.push(
      freeDisplayLineItem({
        id: `promo-${promoItem.code}`,
        imageUrl: promoItem.imageURL,
        title: promoItem.lineItemTitle,
        type: "discount",
      }),
    );
  }

  return items;
};
